module.exports = __webpack_public_path__ + "img/game-and-watch.429e5e02.png";